import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private _parentUrl!: string;
  private _schema!: string;

  get parentUrl() {
    return this._parentUrl;
  }

  get schema() {
    return this._schema;
  }

  setData(queryParam: any) {
    this._schema = queryParam.schema;
    this._parentUrl = queryParam.parentUrl;
  }
}
